import React, { useState, useEffect } from 'react';
import {
    Loader2,
    AlertCircle,
  IndianRupee,
  Settings,
  Globe,
  PackageSearch,
  Boxes,
  BadgeCheck,
} from 'lucide-react';


import { fetchAssignedServiceData } from '../../services/customerService';

const AssignedReport = () => {
const [filters, setFilters] = useState({
  total_data: 90,
  user_id: '',
  service_id: '',
  package_id: '',
});


  const [reportData, setReportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasInitialLoad, setHasInitialLoad] = useState(false);
  const [userData, setUserData] = useState({});

  // Fetch data from API
  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const apiParams = {
        total_data: filters.total_data,
        ...(filters.user_id && { user_id: filters.user_id.trim() }),
        ...(filters.service_id && { service_id: parseInt(filters.service_id) }),
        ...(filters.package_id && { package_id: parseInt(filters.package_id) }),
      };

      const response = await fetchAssignedServiceData(apiParams);

if (response.error) {
  setError(response.error);
  setReportData([]);
} else {
  const uData = response.user || {};
  setUserData(uData);
  const data = response.data || response;
  
  const cleaned = Array.isArray(data) ? data : [];
  setReportData(cleaned);
  
}

    } catch (err) {
      setError(err.message || 'Failed to fetch data');
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasInitialLoad) {
      fetchData();
      setHasInitialLoad(true);
    }
  }, [hasInitialLoad]);

  useEffect(() => {
    applyLocalFilters();
  }, [reportData]);

  const applyLocalFilters = () => {
    setFilteredData([...reportData]);
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleApplyFilters = () => {
    fetchData();
  };


  return (
    <div className="p-4 mt-6">


<div className="bg-white p-2 rounded-md shadow mb-2">
  <h3 className="text-lg font-semibold mb-3 text-center">Assigned Service Reports</h3>
<div className="flex items-end gap-6 justify-center">

  {/* User ID Field */}
  <div className="w-1/4">
    <label className="block text-md font-bold text-gray-700">
      User ID <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      value={filters.user_id}
      onChange={(e) => handleFilterChange('user_id', e.target.value)}
      placeholder="APID0326"
      className="w-full border px-2 py-2 rounded-md border-blue-600 uppercase"
    />
  </div>



</div>
{/* User Info */}
<div className="flex justify-center mt-4">
  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 shadow-sm w-full max-w-3xl">

    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-800">

      <p>
        <span className="font-semibold text-gray-700">Name:</span>{" "}
        {userData?.name || "-"}
      </p>

      <p>
        <span className="font-semibold text-gray-700">Authorized Sign Name:</span>{" "}
        {userData?.company_details?.authorized_person_name || "-"}
      </p>

      <p>
        <span className="font-semibold text-gray-700">Created At:</span>{" "}
        {userData?.created_at || "-"}
      </p>

      <p>
        <span className="font-semibold text-gray-700">Company Name:</span>{" "}
        {userData?.company_details?.company_name || "-"}
      </p>

    </div>
  </div>
</div>



  <div className="mt-4 flex justify-center">
    <button
      onClick={handleApplyFilters}
      className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-2 py-1 rounded-md"
    >
      Search
    </button>
  </div>
</div>



<div className='flex justify-center'>
<h2 className="text-xl font-bold mb-2 text-center text-white bg-gradient-to-r from-blue-500 to-purple-500 py-1 px-2 rounded shadow">
  Assigned Report
</h2></div>

{loading ? (
  <div className="flex items-center justify-center gap-2 text-blue-500 text-lg font-semibold">
    <Loader2 className="animate-spin" /> Loading...
  </div>
) : error ? (
  <div className="text-red-600 flex items-center justify-center gap-2 font-semibold">
    <AlertCircle /> {error}
  </div>
) : filteredData.length === 0 ? (
  <div className="text-gray-500 text-center font-semibold">No data found.</div>
) : (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
    {filteredData.map((item, idx) => (
      <div
        key={idx}
        className="border rounded-xl shadow-md hover:shadow-xl bg-gradient-to-br from-white to-gray-50 p-4 transition-transform duration-200 transform hover:-translate-y-1"
      >
        <div className="flex items-center gap-2 mb-2">
          <IndianRupee className="w-5 h-5 text-blue-600" />
          <span className="font-bold text-gray-700">Price:</span>
          <span className="font-bold text-gray-900 ml-auto">
            ₹ {item?.assignment.charges_commission?.service_charge?.amount || 'N/A'}
          </span>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <Settings className="w-5 h-5 text-purple-600" />
          <span className="font-bold text-gray-700">Charge Type:</span>
          <span className="font-bold text-gray-900 ml-auto">
            {item?.assignment.charges_commission?.service_charge?.charge_type || 'N/A'}
          </span>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <Globe className="w-5 h-5 text-green-600" />
          <span className="font-bold text-gray-700">Environment:</span>
          <span className="font-bold text-gray-900 ml-auto">
            {item?.assignment.environment || 'N/A'}
          </span>
        </div>
         

        <div className="flex items-center gap-2 mb-2">
          <PackageSearch className="w-5 h-5 text-indigo-600" />
          <span className="font-bold text-gray-700">Service:</span>
          <span className="font-bold text-gray-900 ml-auto text-sm">
            {item?.service?.service_name || 'N/A'}
          </span>
        </div>

               <div className="flex items-center gap-2 mb-2">
          <PackageSearch className="w-5 h-5 text-indigo-600" />
          <span className="font-bold text-gray-700">Scope:</span>
          <span className="font-bold text-gray-900 ml-auto text-xs">
            {item?.assignment.scope || 'N/A'}
          </span>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <Boxes className="w-5 h-5 text-yellow-600" />
          <span className="font-bold text-gray-700">Package:</span>
          <span className="font-bold text-gray-900 ml-auto">
            {item?.assignment.package?.name || 'N/A'}
          </span>
        </div>

        <div className="flex items-center gap-2 mt-3">
          <BadgeCheck className="w-5 h-5 text-teal-600" />
          <span className="font-bold text-gray-700">Status:</span>
          <span
            className={`ml-auto inline-block px-3 py-1 rounded-full text-xs font-bold ${
              item.assignment.status?.value === 'active'
                ? 'bg-green-600 text-white'
                : 'bg-red-600 text-white'
            }`}
          >
            {item.assignment.status?.value?.toUpperCase() || 'N/A'}
          </span>
        </div>
      </div>
    ))}
  </div>
)}

</div>

  );
};

export default AssignedReport;
